<template>
  <common-dashboard-card-template
    :isDataFound="jobs && jobs.length"
    @removeItem="$emit('removeItem')"
  >
    <template #header>
      <div style="cursor: pointer;" class="flex-row flex__left" @click="$emit('viewMore')">
        <span class="margin-right-15 font-size__large">
          <template v-if="unreadDocCount !== undefined">
            <el-badge :value="unreadDocCount > 9 ? '+9' : `${unreadDocCount}`">
              <i class="far fa-inbox-in fa-fw color__white"></i>
            </el-badge>
          </template>
          <template v-else>
            <i class="far fa-inbox-in fa-fw color__white"></i>
          </template>
        </span>
        <h3 class="tt1 color__white">{{ cardTitle }}</h3>
        <i
          style="margin-left: 10px"
          class="far fa-arrow-to-right color__white font-size__large clickable"
        ></i>
      </div>
    </template>

    <template #body>
      <div v-if="jobs && jobs.length">
        <template v-for="item in jobs">
          <doc-dashboard-card-item
            :type="type"
            :key="getItemKeyFn(item)"
            :item="item"
            @click="itemClick(item)"
          ></doc-dashboard-card-item>
        </template>
      </div>
    </template>
  </common-dashboard-card-template>
</template>
<script>
import CardTemplateV2 from "../common/layout/card-template-v2";
import CommonDashboardCardTemplate from "../common/layout/common-dashboard-card-template";
import DocDashboardCardItem from "./doc-dashboard-card-item";

export default {
  name: "job-dashboard-card",
  props: [
    "cardTitle",
    "jobs",
    "unreadDocCount",
    "getItemKeyFn",
    "type",
    "viewMore",
  ],
  components: {
    DocDashboardCardItem,
    CommonDashboardCardTemplate,
    CardTemplateV2,
    VuePerfectScrollbar: () => import("vue-perfect-scrollbar"),
  },
  methods: {
    itemClick(item) {
      this.$emit("viewDetail", item);
    },
  },
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/views/dashboard/job-dashboard-card.vue